import { render } from "./CargaQR.vue?vue&type=template&id=348d638a&scoped=true"
import script from "./CargaQR.vue?vue&type=script&lang=js"
export * from "./CargaQR.vue?vue&type=script&lang=js"

import "./CargaQR.vue?vue&type=style&index=0&id=348d638a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348d638a"]])

export default __exports__